import { render, staticRenderFns } from "./Budget.vue?vue&type=template&id=65376124&scoped=true"
import script from "./Budget.vue?vue&type=script&lang=js"
export * from "./Budget.vue?vue&type=script&lang=js"
import style0 from "./Budget.vue?vue&type=style&index=0&id=65376124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65376124",
  null
  
)

export default component.exports